import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '@/components/SectionTitle';
import Seo from '@/seo/Seo';
import { PAGE_SEO } from '@/seo/seoConfig';
import { breadcrumbSchema } from '@/seo/schemas';
import { BookOpen, Sparkles, HandHeart, Heart, ArrowRight } from 'lucide-react';

const SERVICES = [
  { to: '/services/sunday-school', icon: BookOpen, title: 'Sunday School', desc: 'Helping children grow in the knowledge of God through Bible stories, worship, prayer, crafts, memory verses, and caring guidance.',
    img: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=900&h=675&fit=crop' },
  { to: '/services/summer-camp', icon: Sparkles, title: 'Summer Camp', desc: 'Five unforgettable days of Bible lessons, worship, games, crafts, memory verses and friendship for children ages 5–14.',
    img: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=900&h=675&fit=crop' },
  { to: '/services/prayer-cell', icon: HandHeart, title: 'Prayer Cell', desc: 'Worship, intercession, encouragement, healing prayer, and spiritual growth in the Word of God.',
    img: 'https://images.unsplash.com/photo-1519834785169-98be25ec3f84?w=900&h=675&fit=crop' },
  { to: '/services/evangelism', icon: Heart, title: 'Evangelism', desc: 'Carrying the message of Jesus Christ into the local community through prayer, testimony, compassion, invitation, and practical service.',
    img: 'https://images.unsplash.com/photo-1529070538774-1843cb3265df?w=900&h=675&fit=crop' },
];

export default function Services() {
  return (
    <div>
      <Seo
        title={PAGE_SEO.services.title}
        titleExact
        description={PAGE_SEO.services.description}
        keywords={PAGE_SEO.services.keywords}
        path="/services"
        jsonLd={[breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Services', path: '/services' }])]}
      />
      <section className="gradient-purple text-white py-12 sm:py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center">
          <div className="text-moj-gold text-sm font-bold uppercase tracking-[0.3em] mb-3">Ministries</div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white mb-4">Our Services</h1>
          <p className="text-lg text-white/90 max-w-3xl mx-auto">Find your place to grow, serve and shine for Christ at Ministry of Jesus.</p>
        </div>
      </section>

      <section className="py-20 bg-moj-cream">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <SectionTitle kicker="Choose your path" title="Discover Our Ministries" center />
          <div className="grid sm:grid-cols-2 gap-8">
            {SERVICES.map((s) => (
              <article key={s.to} className="card-moj overflow-hidden group flex flex-col" data-testid={`service-${s.to.split('/').pop()}`}>
                <img src={s.img} alt={s.title} className="w-full h-56 object-cover"/>
                <div className="p-6 flex-1 flex flex-col">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-12 h-12 rounded-xl gradient-purple flex items-center justify-center">
                      <s.icon size={22} className="text-moj-gold"/>
                    </div>
                    <h3 className="font-serif text-2xl text-moj-purple-deep">{s.title}</h3>
                  </div>
                  <p className="text-moj-charcoal/80 mb-6 flex-1">{s.desc}</p>
                  <Link to={s.to} className="btn-primary self-start">Learn More <ArrowRight size={16}/></Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
